import React, { useState } from "react";
import style from "./style.module.css";
import HeadLines from "../../CommonComponents/HeadLines";
import InputText from "../../CommonComponents/InputText";
import { AppStore, PlayStore, topRightWhiteArrow } from "../../icon_assets";
import { URL_CONFIG } from "../../../../../_constants/Config/URL_CONFIG";
import uatQRLink from "./../../DesktopImages/Home/uatQRLink.png";
import liveQRLink from "./../../DesktopImages/Home/liveQRLink.png";
import { Validation } from "../../../../../_helpers/validation/Validation";
import { userDetail } from "../../GetInTouch/constant";
import { postAppLink } from "../../../../../_services/Arya2.0/Homepage";
import { customToastr } from "../../CustomToastr";
import { isMobile } from "../../helperFunc";
import MultiLangTranslate from "../../../../../_components/Translate/MultiLangTranslate";
const DownloadAryaAg = () => {
  const initiate = { number: "" };
  const [number, setNumber] = useState("");
  const [disable, setDisable] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(initiate);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setNumber(value);
      setData({ number: value });
      setDisable(value.length !== 10);
    }
  };

  const sendAppLink = async () => {
    const validationErrors = Validation(data, userDetail());
    setError(validationErrors);

    // Check if there are no validation errors
    if (
      Object.keys(validationErrors).every((key) => validationErrors[key] === "")
    ) {
      const dataObj = { mobile: data.number };
      const res = await postAppLink(dataObj);
      if (res?.status === "success") {
        customToastr({ text: "Link sent successfully!", type: "success" });
      } else {
        customToastr({ text: "Failed to send link", type: "error" });
      }
    }
  };

  return (
    <>
      <div
        className={`${
          isMobile
            ? `margin-top30 ${style["mobDownloadDiv"]}`
            : `${style["DownloadDiv"]}`
        } `}
      >
        {/* <div className={style["downloadText"]}> */}
        <HeadLines
          className={
            isMobile ? style["mobDownloadText"] : style["downloadText"]
          }
        >
          <MultiLangTranslate title="Download" />{" "}
          <span
            className={
              isMobile
                ? style["mobaryaAgBackground"]
                : style["aryaAgBackground"]
            }
          >
            Arya.ag
          </span>{" "}
          <MultiLangTranslate title="App" />
        </HeadLines>
        {/* </div> */}
        <HeadLines
          text="Log in easily with MPIN or Fingerprint and get real-time notifications. Enter your mobile number for the download link or scan the QR code."
          className={`font-weight400 font-size12 line-height14 colorDark14 ${
            isMobile ? "margin-top16" : "margin-top24"
          }`}
        />
        <div
          className={`${style["marginTop28"]} d-flex align-items-center gap8`}
        >
          <InputText
            className={`${style["inputClass"]}`}
            placeholder="Contact Number"
            value={number}
            onChange={handleInputChange}
            maxLength={10}
            type="number"
          />
          <div
            className={`${style["imgBackground"]} ${
              disable ? style["disableimgbackground"] : "cursorPointer"
            }`}
            onClick={sendAppLink}
          >
            <img src={topRightWhiteArrow} />
          </div>
        </div>
        <div
          className={`${
            isMobile
              ? "margin-top30 margin-left16 margin-right16"
              : "margin-top40"
          } d-flex align-items-center justify-content-space-between`}
        >
          <div
            className={`d-flex align-items-center flex-d-col ${
              isMobile ? "gap12" : "gap32"
            }`}
          >
            <div
              className={`${
                isMobile ? style["googlePlayMobDiv"] : style["googlePlayDiv"]
              }`}
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=arya.ag",
                  "_blank"
                )
              }
            >
              <div className="d-flex align-items-center gap10">
                <img
                  src={PlayStore}
                  style={{ width: "20px", height: "20px" }}
                />
                <div className="d-flex flex-d-col">
                  <HeadLines
                    text={"GET IT ON"}
                    className={
                      isMobile ? style["getmobspan"] : style["getspan"]
                    }
                  />
                  <HeadLines
                    text={"Google Play"}
                    className={
                      isMobile
                        ? style["googlePlaymobSpan"]
                        : style["googlePlaySpan"]
                    }
                  />
                </div>
              </div>
            </div>

            <div
              className={`${
                isMobile ? style["googlePlayMobDiv"] : style["googlePlayDiv"]
              }`}
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/arya-marketplace/id1621681339",
                  "_blank"
                )
              }
            >
              <div className="d-flex align-items-center gap10">
                <img src={AppStore} style={{ width: "20px", height: "20px" }} />
                <div className="d-flex flex-d-col">
                  <HeadLines
                    text={"Download on the"}
                    className={
                      isMobile ? style["getmobspan"] : style["getspan"]
                    }
                  />
                  <HeadLines
                    text={"App Store"}
                    className={
                      isMobile
                        ? style["googlePlaymobSpan"]
                        : style["googlePlaySpan"]
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${
              isMobile
                ? style["mobScannerBorderClass"]
                : style["scannerBorderClass"]
            }`}
          >
            <img
              className={`${
                isMobile ? style["mobscannerClass"] : style["scannerClass"]
              }`}
              alt="Download Scanner"
              src={
                window?.location?.href?.includes("uat") ? uatQRLink : liveQRLink
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadAryaAg;
